/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Rebooking'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019.2020  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeRebooking from '../../../components/rebooking/Home.vue';
import PassengersRebooking from '../../../components/rebooking/rebookingpassengers/RebookingPassengers.vue'; // Paxes for Rebooking
import FlightSearchResultsRebooking from '../../../components/rebooking/flightsearchresults/FlightSearchResults.vue'; // FlightSearchResults for Rebooking
import PaymentsRebooking from '../../../components/shared/payment/Payment.vue'; // Payments for Rebooking (from 'shared')
import OverviewRebooking from '../../../components/shared/overview/Overview.vue'; // Overview for Rebooking (from 'shared')
import ConfirmationRebooking from '../../../components/shared/confirmation/Confirmation.vue'; // Confirmation for Rebooking (from 'shared')


export const routesrebooking = [
    { path: '', component: HomeRebooking },
    { path: '/rebookingpassengers/:modulo?', name: 'PassengersRebooking', component: PassengersRebooking, props: true }, // Step: 2
    { path: '/flightsearchresults/:modulo?', name: 'FlightSearchResultsRebooking', component: FlightSearchResultsRebooking, props: true }, // Step: 3
    { path: '/payment/:modulo?', name: 'PaymentsRebooking', component: PaymentsRebooking, props: true }, // Step: 4
    { path: '/overview/:modulo?', name: 'OverviewRebooking', component: OverviewRebooking, props: true }, // Step: 5
    { path: '/confirmation/:modulo?', name: 'ConfirmationRebooking', component: ConfirmationRebooking, props: true }, // Step: 6
];



// WEBPACK FOOTER //
// ./src/routes/modules/rebooking/routes.js